import { Link } from 'react-router-dom';
import { ArrowUpRight, Clock } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { Reveal } from '../components/Reveal';
import { posts } from '../data/content';

export const InsightsTeaser = () => (
  <section data-testid="insights-teaser-section" className="bg-paper">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <SectionHeading
          chapter="09"
          eyebrow="Blog & Digital Insights"
          title="Insights for Your Digital Growth."
          copy="Practical, educational reads on marketing, visibility, branding, and digital skills."
        />
        <Reveal delay={0.2}>
          <Link to="/insights" data-testid="insights-view-all" className="btn-outline-dark shrink-0">
            All Insights <ArrowUpRight size={16} />
          </Link>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {posts.slice(0, 3).map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.09} className="h-full">
            <Link
              to={`/insights/${p.slug}`}
              data-testid={`insight-card-${p.slug}`}
              className="card-lift group flex h-full flex-col overflow-hidden rounded-2xl border border-ink/10 bg-white"
            >
              <div className="img-frame aspect-[16/10] rounded-none">
                <img src={p.image} alt={p.imageAlt} loading="lazy" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="mb-3 flex items-center gap-3">
                  <span className="rounded-full bg-forest/10 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.16em] text-forest">
                    {p.category}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-ink">
                    <Clock size={12} /> {p.readingTime}
                  </span>
                </div>
                <h3 className="font-display text-lg font-bold leading-snug text-ink transition-colors duration-300 group-hover:text-forest">
                  {p.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-ink">{p.excerpt}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
